import { Extension } from "@tiptap/core";
import { PluginKey } from "@tiptap/pm/state";
import { Suggestion, SuggestionOptions } from "@tiptap/suggestion";

import { DOT_PHRASE_TRIGGER_PREFIX } from "../constants/dot-phrases";
import { InsertableDotPhrase } from "../types/insertable-dot-phrase";
import { matchDotPhrases } from "../utils/match-dot-phrases";

const DOT_PHRASE_SUGGESTION_PLUGIN_NAME = "dotPhraseSuggestion";

interface DotPhraseSuggestionState {
  active: boolean;
}

export const dotPhraseSuggestionPluginKey = new PluginKey<DotPhraseSuggestionState>(
  DOT_PHRASE_SUGGESTION_PLUGIN_NAME,
);

const DOT_PHRASE_ALLOWED_PREFIXES = [" "];

/** Ahead of every keymap: the dropdown claims Enter, Tab and the arrows only while it shows phrases. */
const DOT_PHRASE_SUGGESTION_PRIORITY = 1000;

interface DotPhraseSuggestionOptions {
  getDotPhrases: () => InsertableDotPhrase[];
  getIsTriggerEnabled: () => boolean;
  render?: SuggestionOptions<InsertableDotPhrase>["render"];
  command?: SuggestionOptions<InsertableDotPhrase>["command"];
}

export function buildDotPhraseSuggestionItems(getDotPhrases: () => InsertableDotPhrase[]) {
  return ({ query }: { query: string }): InsertableDotPhrase[] =>
    matchDotPhrases(getDotPhrases(), query);
}

const DotPhraseSuggestion = Extension.create<DotPhraseSuggestionOptions>({
  name: DOT_PHRASE_SUGGESTION_PLUGIN_NAME,

  priority: DOT_PHRASE_SUGGESTION_PRIORITY,

  addOptions() {
    return { getDotPhrases: () => [], getIsTriggerEnabled: () => true };
  },

  addProseMirrorPlugins() {
    return [
      Suggestion<InsertableDotPhrase>({
        editor: this.editor,
        pluginKey: dotPhraseSuggestionPluginKey,
        char: DOT_PHRASE_TRIGGER_PREFIX,
        allowedPrefixes: DOT_PHRASE_ALLOWED_PREFIXES,
        items: buildDotPhraseSuggestionItems(this.options.getDotPhrases),
        allow: () => this.options.getIsTriggerEnabled() && this.editor.isFocused,
        render: this.options.render,
        command: this.options.command,
      }),
    ];
  },
});

export default DotPhraseSuggestion;
